export const VIDEO_CONSTRAINS = {
  qvga: { width: 320, height: 240 },
  vga: { width: 640, height: 480 },
  hd: {
    width: 1280,
    height: 720,
  },
  fullhd: { width: 1920, height: 1080 },
};

export const SpatialLayer = {
  LOW: 0,
  MEDIUM: 1,
  HIGH: 2,
};

export const TemporalLayer = {
  BASE: 0,
  MIDDLE: 1,
  HIGH: 2,
};
